import { Component, OnInit} from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { SharedService } from '@shared/services/shared.service';
import { UserService } from 'app/services/user/user.service';
import { IPayment } from '../../models/payment';
import { PaymentService } from '../../service/payment.service';
import { PayDialog } from '../pay/pay-component';
import { AuthService } from '@shared/auth/auth.service';
import { PaymentSlipDialog } from '../payment-slip/payment-slip.component';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})

export class PaymentsComponent implements OnInit {
  public processing: boolean = false;
  public paymentsSource = new MatTableDataSource<IPayment>();
  public payments: IPayment [] = [  ];
  public paymentColumns: string[] = ['type','name','status','paymentCleared','amount','paymentMethod', 'sku', 'comments', 'paymentSlip', 'actions'];
  public cardColor: string = this.sharedService.blue + '20';

  constructor(public paymentService: PaymentService,
              public sharedService: SharedService,
              public authService: AuthService,
              public userService: UserService,
              private dialog: MatDialog,
              private router: Router) { }

  ngOnInit(): void {
    this.getUserPayments();
  }

  getUserPayments() {
    this.processing = true;
    this.userService.getUserPayments().subscribe({
      next: response => {
        this.payments = response;
        this.processing = false;
      },
      error: e => {
        this.processing = false;
        this.sharedService.toastr.error('Unable get user payments');
      },
      complete: () => {
        this.paymentsSource = new MatTableDataSource<IPayment>(this.payments);
      }
    });
  }

  canPay(payment: IPayment): boolean {
    return !payment.paid &&
           !payment.sku.includes('HOSPL') &&
           !payment.sku.includes('SICF') &&
           payment.applicationStatus != this.paymentService.paymentPendingStatus &&
           payment.status != this.paymentService.paymentAwaitingClearanceStatus;
  }

  viewRemittanceSlip(payment: IPayment) {
    this.dialog.open(PaymentSlipDialog, {
      data: {
        sku: payment.sku,
        feeType: payment.type,
        entityType: payment.entityType,
        id: Number(payment.entityId)
      },
      role: 'dialog',
      ariaLabel: 'Remittance Slip Dialog',
      minWidth: !this.sharedService.mobile ? '400px' : '300px',
      maxWidth: !this.sharedService.mobile ? '800px' : '300px'
    });
  }

  payOnline(id: number, entityType: string, comments: string) {
    let showConfirmation = false;
    if (comments != null && comments.indexOf(this.paymentService.paymentIssuedCommentSearchText) >= 0) {
      showConfirmation = true;
    }
    if (showConfirmation) {
      this.sharedService.openConfirm(`Looks like you have already attempted a payment for this license.
                                      For payments to completely clear through the system, it can take upto 3 business days.
                                      Most payments are processed within 24 hrs.  Do you want to continue?`);
      this.sharedService.confirmed().subscribe(confirmed => {
        if (confirmed) {
          this.processing = true;
          this.paymentService.negotiateToken(id, entityType).subscribe({
            next: response => window.location.href = response,
            error: e => {
              this.processing = false;
              this.sharedService.toastr.error('Unable communicate with payment processor.  Please try again later.' + e.message);
            }
          });
        }
      });
    }
    else{
      this.processing = true;
      this.paymentService.negotiateToken(id, entityType).subscribe({
        next: response => window.location.href = response,
        error: e => {
          this.processing = false;
          this.sharedService.toastr.error('Unable communicate with payment processor.  Please try again later.' + e.message);
        }
      });
    }
  }

  pay(entityType: string, feeType: string, id: number, comments: string, sku: string) {
    this.router.navigate(['/pay-online/' + id], { queryParams: { entityType: entityType } });
    let showConfirmation = false;
    if (comments != null && comments.indexOf(this.paymentService.paymentIssuedCommentSearchText) >= 0) {
      showConfirmation = true;
    }
    if (showConfirmation) {
      this.sharedService.openConfirm(`Looks like you have already attempted a payment for this license.
                                      For payments to completely clear through the system, it can take upto 3 business days.
                                      Most payments are processed within 24 hrs.  Do you want to continue?`);
      this.sharedService.confirmed().subscribe(confirmed => {
        if (confirmed) {
          this.dialog.open(PayDialog, {
            data: {
              entityType: entityType,
              feeType: feeType,
              canPay: true,
              sku: sku,
              id: Number(id)
            },
            role: 'dialog',
            ariaLabel: "Fee Information Dialog",
            minWidth: !this.sharedService.mobile ? '400px' : '300px',
            maxWidth: !this.sharedService.mobile ? '800px' : '300px',
            maxHeight: !this.sharedService.mobile ? '800px' : '500px',

          });
        }
      });
    }
    else {
      this.dialog.open(PayDialog, {
        data: {
          entityType: entityType,
          feeType: feeType,
          canPay: true,
          sku: sku,
          id: Number(id)
        },
        role: 'dialog',
        ariaLabel: "Fee Information Dialog",
        minWidth: !this.sharedService.mobile ? '400px' : '300px',
        maxWidth: !this.sharedService.mobile ? '800px' : '300px',
        maxHeight: !this.sharedService.mobile ? '800px' : '500px',

      });
    }
  }

  formatAmount(amount: any): string {
    if (typeof amount === 'string' && amount.includes(',')) {
      return amount;
    }

    const numAmount = typeof amount === 'number' ? amount : parseFloat(amount);

    if (!isNaN(numAmount)) {
      return numAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    return String(amount);
  }
}


